export const classification_root = (x) => {
    switch (x) {
        case 'estimate': return 'estimate';
        case 'estimate-approved': return 'estimate';
        case 'order': return 'order';
        case 'invoice': return 'invoice';
        case 'invoice-semipaid': return 'invoice';
        case 'invoice-paid': return 'invoice';
    }
};
export const classification_paid = (x) => {
    switch (x) {
        case 'invoice-semipaid': return 'semipaid';
        case 'invoice-paid': return 'fullpaid';
        default: return null;
    }
};
